import React from 'react';
import { IAttendeeOrganizationDTO, MeetingAttendeeStatus } from '../../../../../../api/attendees.dao';
import Text from '../../../../../global/text/text';
import { IConnectionAttendeeDTO } from '../../../../../../api/connections.dao';
import './attendee-joined-counter.scss';
import { Space } from '../../../../../../constants/html-character-entities';


interface IProps {
    organizations: IAttendeeOrganizationDTO[];
    isCollapsed: boolean;
    totalCount: number;
}

const AttendeeJoinedCounter = (props: IProps) => {
    const { organizations, isCollapsed, totalCount } = props;

    const joinedCount = organizations.reduce((acc: number, organization: IAttendeeOrganizationDTO) => {
        const organizationCount = organization.attendees.reduce((organizationAcc: number, attendee: IConnectionAttendeeDTO) => {
            if (attendee.status === MeetingAttendeeStatus.JOINED || attendee.status === MeetingAttendeeStatus.WALK_IN) return organizationAcc + 1;

            return organizationAcc;
        }, 0);

        return acc + organizationCount;
    }, 0);

    return (
        <div className='attendee-joined-counter'>
            <div className='attendee-joined-counter__joined'>
                <strong>{joinedCount}</strong>
                <Space />
                <Text
                    className='attendee-joined-counter__label'
                    message='Joined'
                    id='oe.attendee.joined'
                    description='Label text'
                />
            </div>
            { !isCollapsed && (
                <div className='attendee-joined-counter__total'>
                    <strong>{totalCount}</strong>
                    <Space />
                    <Text
                        className='attendee-joined-counter__label'
                        message='Total'
                        id='oe.attendee.total'
                        description='Label text'
                    />
                </div>
            )}
        </div>
    );
};

export default AttendeeJoinedCounter;
